const userReducer = (
    state = {
      token: "",
      user_type: "",
      email:'',
      game_id: null,
      session: 0,
    },
    action
  ) => {
    switch (action.type) {
      case "LOGIN":
        return {
          token: action.payload.token,
          user_type: action.payload.user_type,
          email:action.payload.email,
          game_id: action.payload.game_id,
          session:1,
        };
      case "UPDATE_USER":
        return {
          ...state,
          email: action.payload.email,
        };
      case "LOGOUT":
      case "SET_AUTHENTICATED_NULL":
      case "SET_AUTHENTICATED_FALSE":
        return {
          token: "",
          user_type: "",
          email:'',
          game_id: null,
          session: 0,
        };
      case "SET_SESSION_ENDED":
        return {
            token: "",
            user_type: "",
            email:'',
            game_id: null,
            session: 99,
          };
      default:
        return state;
    }
  };
  
  export default userReducer;
  